import { useState, useEffect } from "react";
import {
  Box,
  Button,
  CardMedia,
  Card,
  TextField,
  Autocomplete,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress, rsParentCom } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseHomeMagazine } from "./UseHomeMagazine";
import { FileUploader } from "react-drag-drop-files";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function CategoryInformation(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const navigate = useNavigate();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const { validate, GetHomeMagazines, addMagazine, updateMagazine } =
    UseHomeMagazine();
  const [offers] = useState();
  const [items, setItems] = useState();
  const headerColors = ["بدون رنگ", "primary", "secondary"];
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    id: 0,
    aid: location.state.MagazineID ? location.state.MagazineID : 0,
    title: undefined,
    headerColorName: null,
    moreTitle: undefined,
    moreURL: undefined,
  });

  const [imgState, setImgState] = useState({
    file: undefined,
    url: state.icon ? state.icon : "",
  });

  useEffect(() => {
    if (location.state.MagazineID) {
      setState({
        aid: location.state.MagazineID,
        id: 0,
        title: "",
      });
      setProgress(true);
      GetHomeMagazines(location.state.MagazineID, (callback) => {
        setState({
          aid: callback.aid == 0 ? location.state.MagazineID : callback.aid,
          id: callback.id,
          title: callback.title,
          headerColorName: callback.headerColorName,
          moreTitle: callback.moreTitle,
          moreURL: callback.moreURL,
        });
        setImgState({
          file: undefined,
          url: callback.icon ? callback.icon : "",
        });
      });
    }
  }, [location.state]);

  const [errorState, setErrorState] = useState({
    title: false,
  });

  const handleChangeImage = (file) => {
    setImgState({
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });
  };

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: msParentCom.backUrl,
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/MagazineManage",
            MagazineID: location.state.MagazineID,
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn={isSmall ? "span 12" : "span 4"}>
          <TextField
            fullWidth
            value={state.title ? state.title : ""}
            error={errorState.title}
            label="عنوان"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, title: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 8"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 4"}>
          <TextField
            fullWidth
            value={state.moreTitle ? state.moreTitle : ""}
            label="عنوان لینک"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, moreTitle: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 8"></Box>}
        <Box gridColumn="span 6">
          <TextField
            fullWidth
            value={state.moreURL ? state.moreURL : ""}
            label="آدرس لینک"
            sx={{
              textarea: {
                direction: "rtl",
              },
            }}
            multiline
            rows={2}
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, moreURL: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 6"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <Autocomplete
            size="small"
            value={state.headerColorName ? state.headerColorName : ""}
            onChange={(event, newValue) => {
              if (newValue == "بدون رنگ") {
                setState({
                  ...state,
                  headerColorName: null,
                });
              } else if (newValue) {
                setState({
                  ...state,
                  headerColorName: newValue,
                });
              } else {
                setState({
                  ...state,
                  headerColorName: null,
                });
              }
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            sx={{ width: "80%" }}
            getOptionLabel={(option) => option}
            fullWidth
            options={headerColors}
            renderInput={(params) => (
              <TextField variant="outlined" {...params} label="رنگ هدر" />
            )}
          />
        </Box>
        <Box gridColumn="span 9"></Box>
        <Box
          gridColumn={isSmall ? "span 12" : "span 3"}
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 5,
          }}
        >
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "60px", height: "auto" }}>
                <Card
                  sx={{
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.url ? imgState.url : "/static/img/no-photos.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
        </Box>
        <Box gridColumn="span 9"></Box>
        <Box
          gridColumn={isSmall ? "span 12" : "span 4"}
          sx={{ my: 2, display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => {
              if (validate(state, setErrorState) == 200) {
                setProgress(true);
                if (state.id == 0) {
                  addMagazine(state, imgState.file, () => {
                    GetHomeMagazines(state.aid, (callback) => {
                      setState({
                        aid: callback.aid,
                        id: callback.id,
                        title: callback.title,
                        headerColorName: callback.headerColorName,
                        moreTitle: callback.moreTitle,
                        moreURL: callback.moreURL,
                      });
                      setImgState({
                        file: undefined,
                        url: callback.icon ? callback.icon : "",
                      });
                    });
                  });
                } else {
                  updateMagazine(state, imgState.file, () => {
                    GetHomeMagazines(state.aid, (callback) => {
                      setState({
                        aid: callback.aid,
                        id: callback.id,
                        title: callback.title,
                        headerColorName: callback.headerColorName,
                        moreTitle: callback.moreTitle,
                        moreURL: callback.moreURL,
                      });
                      setImgState({
                        file: undefined,
                        url: callback.icon ? callback.icon : "",
                      });
                    });
                  });
                }
              }
            }}
          >
            ثبت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
